import jwtDecode from "jwt-decode";
import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
// import { changeUserStateSSO } from "../login/actions";
import { setUrlToRedirectAfterLogout } from "../route/LocalStorage";
import { State } from "../state";
import { DecodedToken } from "./types";

const userAsyncActionCreator = actionCreatorFactory("Okta");
const userAsyncFactory = asyncFactory<State>(userAsyncActionCreator);
export const exchangeCode = userAsyncFactory<any, any>(
  "EXCHANGE_CODE",
  async (params, dispatch, getState) => {
    try {
      const pairOfTokens = await api.login.exchangeCode(
        params.code,
        params.grantType,
        params.redirectUri,
        params.scope,
        params.ssoCredentials
      );

      setUrlToRedirectAfterLogout("/login_sso");

      if (pairOfTokens.access_token) {
        const decodedToken: DecodedToken = jwtDecode(pairOfTokens.access_token);

        dispatch({
          payload: {
            issuedAt: decodedToken.iat,
            expiresIn: decodedToken.exp,
            access_token: pairOfTokens.access_token,
            lastUsed: decodedToken.auth_time,
            userId: decodedToken.email
          },
          type: "SET_USER"
        });
      }
      return;
    } catch (error) {
      // tslint:disable-next-line: no-console
      console.log("error.message: ", error.message);

      return "ErrorLoggedOutUser();";
    }
  }
);
const exchangeCodeAction = thunkToAction(exchangeCode.action);
export type ExchangeCodeActionType = typeof exchangeCodeAction;



// WEBPACK FOOTER //
// ./src/redirectComponent/actions.ts